import VaccinesIcon from '@mui/icons-material/Store';
import { StoreList } from './Store.List';
import { StoreCreate } from './Store.Create';
import { StoreEdit } from './Store.Edit';
import { StoreUpload } from './Store.Upload';

export default {
    list: StoreList,
    create: StoreCreate,
    edit: StoreEdit,
    upload: StoreUpload,
    icon: VaccinesIcon,
};
